import logEvent from '../../logEvent';

function logEventAssistedCancelContribution(code, data) {
  logEvent(`UFCC-${code}`, data);
}

export function logEventAssistedCancelContributionSelectPlan() {
  logEventAssistedCancelContribution('01');
}

export function logEventAssistedCancelContributionDetails(data) {
  logEventAssistedCancelContribution('02', data);
}

export function logEventAssistedCancelContributionSchedule() {
  logEventAssistedCancelContribution('03');
}

export function logEventAssistedCancelContributionSuccess() {
  logEventAssistedCancelContribution('04');
}

export function logEventAssistedCancelContributionFailure() {
  logEventAssistedCancelContribution('05');
}

export function logEventAssistedCancelContributionCannotSubmitted() {
  logEventAssistedCancelContribution('06');
}

export function logEventAssistedCancelContributionNoContributions() {
  logEventAssistedCancelContribution('07');
}
